module.exports = __webpack_public_path__ + "img/full4-min.e375e6eb.png";